import { GetAddressPostcodeSuggestionQuery } from '@zoopla/listing-search-queries';

type GeoLocationItem = {
    geoIdentifier: string;
    geoLabel: string;
    geoSubLabel: string;
};

export const transformGeoLocationData = (geoData: GeoLocationItem[]) => {
    const result = geoData.map((geo: GeoLocationItem) => ({
        id: geo.geoIdentifier,
        value: geo.geoLabel,
        subValue: geo.geoSubLabel
    }));

    return result;
};

export const transformAddressPostcodeSuggestion = (
    addressPostcodeData: GetAddressPostcodeSuggestionQuery['getSuggestedAddresses'],
    prefixElement?: string
) => {
    const { suggestions } = addressPostcodeData || {};

    if (suggestions && suggestions.length) {
        const transformedSuggestions = suggestions.map((suggestion) => {
            const { urlPath, address } = suggestion || {};

            const value = prefixElement
                ? `${prefixElement} ${address}`
                : address;

            return {
                id: urlPath || '',
                value: value || ''
            };
        });

        return transformedSuggestions;
    }

    return [];
};
